<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4 class="font-weight-bold">{{ setting.name }}</h4>
      </div>
      <div class="col-6">
        <p class="m-0">{{ setting.company_name }}</p>
      </div>
      <div class="col-12">
        <p class="m-0">Contract</p>
      </div>
      <div class="col-12">
        <button class="btn btn-danger mr-3" v-show="status != 'end'" @click="end_contract">End Contract</button>
      </div>
    </div>
    <hr/>
    <div class="row">
      <div class="col-12">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">Contract Information</p>
          <p class="m-0">Status: {{ status }}</p>
          <p class="m-0">Date: {{ date.format('DD MMMM YYYY') }}</p>
        </div>
      </div>
      <div class="col-6 mt-3">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">Helper Information</p>
          <p class="m-0">{{ helper.name }}</p>
          <p class="m-0">{{ helper.phone_number }}</p>
          <p class="m-0">{{ helper.email }}</p>
        </div>
      </div>
      <div class="col-6 mt-3">
        <div v-show="is_loading">
          <skeleton-box
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
          <skeleton-box
            class="mt-3"
            height="30px"
            width="100%"/>
        </div>
        <div v-show="!is_loading">
          <p class="m-0 font-weight-bold">Majikan Information</p>
          <p class="m-0">{{ majikan.name }}</p>
          <p class="m-0">{{ majikan.phone_number }}</p>
          <p class="m-0">{{ majikan.email }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SkeletonBox from '@/layout/skeleton'

export default{
  components:{
    'skeleton-box': SkeletonBox,
  },
  data(){
    return{
      status: '',
      date: moment(),
      helper: {
        name: 'test',
        email: 'test@test.com',
        phone_number: '121221',
      },
      majikan: {
        name: 'test',
        email: 'test@test.com',
        phone_number: '121221',
      },
      is_loading: true,
      setting: {
        name: '',
        company_name: '',
      },
    }
  },
  async created(){
    await this.get_data()
    // await this.get_setting()
    this.is_loading = false
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/contract?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.status = response_data.data.status
          this.date = moment(response_data.data.createdAt)
          this.helper = response_data.data.helper
          this.majikan = response_data.data.majikan
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e.message)
      }
    },
    async get_setting(){
      try{
        var response = await axios.get(base_url+'/setting')

        var response_data = response.data
        if(response_data.status == "success"){
          this.setting = response_data.data
          // console.log(moment(response_data.data.publish_date).format('DD/MM/YYYY'))
        }
      } catch(e) {
        this.$toasted.show(e.message)
      }
    },
    async end_contract(){
      try{
        $('#please_wait_modal').modal('show')
        var data = {}
        data.id = this.$route.query.id
        data.status = 'end'

        var response = await axios.put(base_url+'/contract',data)

        $('#please_wait_modal').modal('hide')
        var response_data = response.data
        if(response_data.status == "success"){
          location.reload()
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e.message)
      }
    },
  }
}
</script>
